import { getBaseCartPath } from '../common'
import { GENERIC_SETUP_ERROR, stripeSetupError } from './stripe_setup_outcome'

export async function prepareStripeCheckout(
  form,
  processorId,
  subtype = 'card',
  { signal } = {}
) {
  const formData = new FormData(form)
  formData.append('payment_method[payment_processor_id]', processorId)
  if (subtype)
    formData.append('payment_method[payment_processor_subtype]', subtype)
  formData.append('_method', 'post')

  let response
  let json
  try {
    response = await fetch(getBaseCartPath() + '/stripe_setup', {
      method: 'POST',
      body: formData,
      signal,
    })
    json = await response.json()
  } catch (error) {
    if (error.name === 'AbortError') throw error

    throw new Error(GENERIC_SETUP_ERROR, { cause: error })
  }

  const setupError = stripeSetupError(response.ok, json)
  if (setupError) throw new Error(setupError)

  return json
}
